import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/project-status")({
  component: lazyRouteComponent(() => import("./-pages/admin.project-status")),
  head: () => ({
    meta: [
      { title: "Project Status · Lecmo Admin" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
